<template>
    <vs-card>
      
        <div>
          <!-- {{subject_ids}} -->
        <!-- <pre>{{lessonLists}}</pre>    -->
          <vs-table
            multiple
            v-model="selected"
            :data="lessonLists"
          >
            <template slot="header">
              <h3>Lessons List</h3>
              <!-- <pre>{{courseLists}}</pre> -->
            </template>
            <template slot="thead">
              <vs-th> Name </vs-th>
              <vs-th> Description </vs-th>
              <vs-th> Subject </vs-th>
              <vs-th> No of Topics </vs-th>
            
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td >
                  {{ data[indextr].name }}
                </vs-td>
                  <vs-td >
                  {{ data[indextr].description }}
                </vs-td>
              
                <vs-td>
                  <span v-for="(subject,index) in data[indextr].subjects" :key="index">
                              {{subject.subject_name}}
                  <span v-if="index+1 < data[indextr].subjects.length">, </span>
                  </span> 
                </vs-td >
               
                      <vs-td >
                  {{data[indextr].topics.length}}
                </vs-td>
               
               
              </vs-tr>
            </template>
          </vs-table>
            <vs-button v-if="query_page.has_next" @click="loadMoreData" style="float:right">Load More Data</vs-button>
           <vs-button class="my-4" @click="exportAssignmentList">Export to Course Builder</vs-button>
        </div>
   
      </vs-card>
</template>
<script>
import vSelect from 'vue-select'
import { newlessonListing } from '@/api/courseBuilder'
import {mapGetters} from 'vuex'
export default {
components: {
  vSelect
},
data () {
  return {
    selected:[],
    lessonLists:[],
    query_page:{
      'total': '',
      'limit': 10,
      'has_next': false,
      'current_page': 1,
      'next_page_url': null,
      'previous_page_url': ''
    },
    sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
    }
  }
},
computed:{
  ...mapGetters(
    ['get_homework_subject_id']
  ),
  selectedLength () {
    if (this.selected.length > 1) {
      return true
    }
  }
},
mounted () {
  this.fetchLessonList()
},
props:{
  subject_ids:{
    type:Array,
    required:true,
    default:() => []
  },
  has_course_all_subject: {
    type: Boolean,
    required: true
  }
},
methods:{
  filterBySubject (subject_ids) {
    this.tagSearch = []
    this.subject_ids = subject_ids
    this.fetchLessonList()
    
  },
  tagSearchWise () {
    this.subject_ids = false
    this.fetchLessonList()

  },
  async fetchLessonList () {
      try {
        this.$vs.loading({
          text: 'Fetching Lesson please wait ...'
        })

        const course_subject_ids = []
        if (!this.has_course_all_subject) {
            this.subject_ids.map((ele) => {course_subject_ids.push(ele.id)})
        }

        let payload = {}
        
        payload = {
            subject_ids: course_subject_ids,
            tag_ids: this.tagSearch,
            is_visible: true
          }
        const customer_id = this.$store.getters.customerId
        //const queryParams = this.$route.query || {}
        //this.query_page.page = queryParams.page || 1
        payload.search = ""
        payload.limit = 10
        const responeList = await newlessonListing(
          customer_id,
          payload,
          this.query_page.current_page,
          this.sorting_obj
        )
        this.lessonLists.push(...responeList.data.data.lesson)
        this.query_page = responeList.data.data.meta
      } catch (error) {
        //
    } finally {
        this.$vs.loading.close()
    }
},
  loadMore () {
    this.loadMoreData()
      
  },
  async loadMoreData () {
    try {
      this.query_page.current_page = this.query_page.current_page + 1
      this.fetchLessonList()

    } catch (error) {
      
    } finally {
      this.$vs.loading.close()
    }


  // 

  },
  exportAssignmentList () {
    if (this.selected.length) {
      const obj = this.selected
      this.$emit('addToLessonArray', obj)
    }

  }
}
}
</script>